<template>
  <div class="ma3-l list-grid">
    <div class="list-item">
      <checkbox label="Приглашено Организатором" id="showOrgInvites" value="showOrgInvites"
        :checked="showOrg" @change="toggleShowOrg"/>
      <checkbox label="Приглашено ТендерПро" id="showTproInvites" value="showTproInvites"
        :checked="showTpro" @change="toggleShowTpro" class="mt2"/>
    </div>
    <invite-item v-for="(item, index) in filteredInvites" :key="index" :item="item" class="list-item" />
  </div>
</template>

<script>
import InviteItem from './InviteItem.vue'
import Checkbox from '@/components/ui/Checkbox.vue'

export default {
  props: ['invites'],
  components: {
    InviteItem,
    Checkbox
  },
  data: () => ({
    showOrg: true,
    showTpro: false
  }),
  computed: {
    filteredInvites () {
      const invites = [...this.invites]
        .sort((l, r) => l.isOrg >= r.isOrg ? -1 : 1)
        .filter(i => ((this.showOrg && i.isOrg) || (this.showTpro && !i.isOrg)))
      return invites
    }
  },
  methods: {
    toggleShowOrg (v) {
      this.showOrg = v.checked
    },
    toggleShowTpro (v) {
      this.showTpro = v.checked
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
